import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import AppFocusLayout from "../components/AppFocusLayout.jsx";
import Button from "../components/Button.jsx";
import Icon from "../components/Icon.jsx";
import ProjectWizard from "../components/projectsAdd/ProjectWizard.jsx";
import ProjectAccessDenied from "./ProjectAccessDenied.jsx";

import projectsApi from "../api/projects.js";
import { setLoading } from "../store/uiSlice.js";
import { getRouteQueryParams } from "../helpers.js";
import { useParams } from "react-router";

export default function ProjectEditPage() {
  const params = useParams();
  const [project, setProject] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();

  const queryParams = getRouteQueryParams(window.location.search);

  useEffect(async () => {
    dispatch(setLoading(true));
    try {
      setProject(await projectsApi.fetchForUpdate(params.id));
    } catch (err) {
      console.error(err);
    }
    setLoaded(true);
    dispatch(setLoading(false));
  }, []);

  if (loaded && !project) {
    return <ProjectAccessDenied />;
  }

  return (
    <AppFocusLayout
      closerAction={
        <Button text to={queryParams.backTo || "/projects"}>
          <Icon>close</Icon>
        </Button>
      }
      title=""
    >
      <div class="row">
        <div class="col l8 push-l2">
          {project && <ProjectWizard project={project} />}
        </div>
      </div>
    </AppFocusLayout>
  );
}
